export declare namespace FileUploadZoneTokenSections {
	interface Drop {
		background: string;
		borderColor: string;
		textColor: string;
		formatsColor: string;
		iconColor: string;
		iconWrapBackground: string;
		titleColor: string;
		actionColor: string;
	}

	interface List {
		itemBackground: string;
	}

	interface Error {
		background: string;
		borderColor: string;
		textColor: string;
		shadow: string;
	}
}

export type FileUploadZoneTokens = {
	drop: FileUploadZoneTokenSections.Drop;
	list: FileUploadZoneTokenSections.List;
	error: FileUploadZoneTokenSections.Error;
};

export const drop: FileUploadZoneTokenSections.Drop = {
	background: '{surface.0}',
	borderColor: '{surface.200}',
	textColor: '{text.color}',
	formatsColor: '{text.muted.color}',
	iconColor: '{primary.300}',
	iconWrapBackground: '{primary.50}',
	titleColor: '{surface.800}',
	actionColor: '{primary.300}',
};

export const list: FileUploadZoneTokenSections.List = {
	itemBackground: '{content.background}',
};

export const error: FileUploadZoneTokenSections.Error = {
	background: '{red.50}',
	borderColor: '{red.200}',
	textColor: '{red.700}',
	shadow: '0 4px 8px rgba(10, 3, 3, 0.04)',
};

export default {
	drop,
	list,
	error,
} satisfies FileUploadZoneTokens;
